import React, {useEffect, useState, useContext} from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization'
import {BaseUrl} from 'contexts/baseUrl/baseUrl';
import DivLayout from 'components/sales/divLayout/divLayout';
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import "./return.css";
import {toast} from "react-toastify";
import CustomModal from "../valetServices/modal";

const ReturnTag = ({
                       getDetailsBySiteId,
                       viewDetails = [],
                       returnTagMrf,
                       history,
                       match,
                       returnTagDetails = []
                   }) => {
    const {baseUrl} = useContext(BaseUrl);
    const [isLoading, setIsLoading] = useState(false);
    const [inputList, setInputList] = useState([{
        material_id: '',
        from_tag: '',
        to_tag: '',
        name: '',
        code: '',
        sale_value: ''
    }]);
    const [count, setCount] = useState(0)

    useEffect(() => {
        (async () => {
            const requestData = {
                lead_id: match.params.lead_id,
                site_id: match.params.id,
            };
            setIsLoading(true);
            await getDetailsBySiteId(requestData);
            setIsLoading(false);
        })();
    }, []);

    const handleAddClick = () => {
        setInputList([...inputList, {
            material_id: '',
            from_tag: '',
            to_tag: '',
            name: '',
            code: '',
            sale_value: ''
        }]);
    };

    const handleRemoveClick = index => {
        const list = [...inputList];
        list.splice(index, 1);
        setInputList(list);
    };

    const handleEntry = (val, key, index, name) => {
        const list = [...inputList];
        // let isAdded = false
        // // eslint-disable-next-line array-callback-return
        // list.map((v, i) => {
        //     if (key === "material_id" && parseInt(v?.material_id) === parseInt(val)) {
        //         list.splice(index, 1);
        //         toast.warning(name + " tag already added to return");
        //         isAdded = true
        //     }
        // })
        //
        // if (isAdded) {
        //     setInputList([...list]);
        //     return true
        // }
        list[index][key] = val;
        if (name !== "") {
            list[index]['name'] = name;
        }

        // eslint-disable-next-line array-callback-return
        viewDetails?.material.map((v) => {
            if (parseInt(val) === parseInt(v.id)) {
                list[index]['code'] = v?.material_code;
                list[index]['sale_value'] = v?.sale_value;
            }
        })
        setInputList([...list]);
    };

    const handleTagSubmit = () => {
        let isError = false
        if (inputList.length > 0) {
            // eslint-disable-next-line array-callback-return
            inputList.some(function (item, key) {
                console.log(item)
                if (item?.material_id === "") {
                    toast.warning("Please choose tag to return")
                    isError = true;
                    return true
                }
                if (item?.material_id !== "" && (item?.from_tag === "" || item?.to_tag === "")) {
                    toast.warning('Please choose from tag or to tag for ' + item?.name)
                    isError = true;
                    return true
                }
            });
        }

        if (isError) {
            return true
        }

        (async () => {
            const payload = {
                tag_data: inputList,
                site_no: viewDetails?.siteData?.site_no
            };
            setIsLoading(true);
            await returnTagMrf(payload);
            setIsLoading(false);
            setCount(count + 1)
        })();
    }

    return (
        <Layout
            title={localization.returnTag}
            isLoading={isLoading}
        >
            <div className="container-fluid bg-sky-blue">
                <div className="details-listing">
                    <DivLayout
                        heading='Site No.'
                        data={viewDetails?.siteData?.site_no}
                    />
                    <DivLayout
                        heading='Busines Name'
                        data={viewDetails?.siteData?.business_name}
                    />
                    <DivLayout
                        heading='Project Id'
                        data={viewDetails?.siteData?.infra_project_id}
                    />
                    <DivLayout
                        heading='Recon Contract Id'
                        data={viewDetails?.siteData?.recon_contract_id}
                    />
                </div>
                <div className="card card-color">
                    <div className="card-body">
                        {returnTagDetails !== null && parseInt(returnTagDetails?.status_code) !== 200 &&
                            <CustomModal msg={returnTagDetails?.message} click={count}/>
                        }
                        {returnTagDetails !== null && parseInt(returnTagDetails?.status_code) === 200 &&
                            <CustomModal msg={returnTagDetails?.message} isPageLoad={true} click={count}
                                         history={history} url={`${baseUrl}/site-listing`}/>
                        }
                        {inputList.map((x, i) =>
                                <>
                                    <div className='row'>
                                        <div className="col-md-3 col-sm-12">
                                            <DropDownInput
                                                name="materialId"
                                                data={viewDetails?.material}
                                                label={localization.material}
                                                required={true}
                                                //isStarRequired={true}
                                                errorMsg={localization.isRequired}
                                                getIdValue={(val) => {
                                                    handleEntry(val.id, 'material_id', i, val?.value);
                                                }}
                                            />
                                        </div>
                                        <div className="col-md-3 col-sm-12">
                                            <ConstantInput
                                                name="fromTagSeries"
                                                label={localization.fromTag}
                                                type="text"
                                                handleChange={(val) => {
                                                    handleEntry(val, 'from_tag', i, '');
                                                }}
                                                value={x.agenda}
                                            />
                                        </div>
                                        <div className="col-md-3 col-sm-12">
                                            <ConstantInput
                                                name="toTagSeries"
                                                label={localization.toTag}
                                                type="text"
                                                handleChange={(val) => {
                                                    handleEntry(val, 'to_tag', i, '');
                                                }}
                                                value={x.toTag}
                                            />
                                        </div>
                                        <div className="col-md-3 col-sm-12 d-flex"
                                             style={{"paddingTop": "0.75rem"}}>
                                            {inputList.length !== 1 &&
                                                <div className="col-md-2 col-sm-5">
                        <span className="ic-minus" onClick={() => handleRemoveClick(i)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                             className="bi bi-dash-circle" viewBox="0 0 16 16">
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                            <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/>
                        </svg>
                        </span>
                                                </div>
                                            }
                                            {inputList.length - 1 === i &&
                                                <div className="col-md-2 col-sm-5">
                        <span className="ic-plus" onClick={() => handleAddClick()}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                             className="bi bi-plus-circle" viewBox="0 0 16 16">
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                            <path
                                d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                        </svg>
                        </span>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </>
                        )}
                        <div style={{'marginTop': '10px'}} className="col-md-12 col-sm-5">
                            <button className="btn btn-sm btn-primary" onClick={handleTagSubmit}>Submit
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default ReturnTag;
